"use strict";

window.FoG = window.FoG || {};

window.FoG.Forms = (function($) {
  function addCharacterCounter($container) {
    var $textareas = $('.countedTextareaContainer', $container);
    
    $.each($textareas, function(idx, el) {
      var $el = $(el);
      var max = $el.data('textareaCounter--count') || 300;
      $el.data('textareaCounter--count', max);
      
      var $counter = $('<div class="textareaCounter"><span class="textareaCounter__count"></span> / <span class="textareaCounter__max"></span>');
      $counter.appendTo($el);
      
      var $count = $('.textareaCounter__count', $counter);
      var $textarea = $('textarea', $el);
      
      $count.text($textarea.val().length);
      $('.textareaCounter__max', $counter).text(max);
      
      var fnUpdateLengthCountSoon = () => {
        window.setTimeout(() => {
          $count.text($textarea.val().length)
        }, 1); 
      };
      
      $textarea.on('keypress', function(e) {
        var length = $textarea.val().length;

        if (!e.metaKey && !e.ctrlKey && e.charCode && length > max) { e.preventDefault(); return false; }
        fnUpdateLengthCountSoon();
        return true;
      });

      $textarea[0].addEventListener('paste', function(e) {
        var clipboardData = e.clipboardData || window.clipboardData;
        var length = $textarea.val().length + clipboardData.getData('Text').length;
        if (length > max) { e.preventDefault(); return false; }
        fnUpdateLengthCountSoon();
        return true;
      });

      $textarea[0].addEventListener('cut', fnUpdateLengthCountSoon);
    });
  }
  
  return {
    addCharacterCounter: addCharacterCounter
  };
})(jQuery);